import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Guid } from 'guid-typescript';
import { FileUploader } from 'ng2-file-upload';
import { AppState } from '../../store/state.model';
import { NgRedux } from '@angular-redux/store';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CmsTicketService {
  constructor(
    public ngRedux: NgRedux<AppState>,
    public datepipe: DatePipe,
  ) { }

  /**
   * @function createUploaderHeaders creates the uploader headers
   * @returns Array<object> the headers for the uploader
   */
  public createUploaderHeaders() {
    return [
      { name: 'Accept', value: 'application/json' },
      { name: 'x-correlationid', value: Guid.create().toString() },
      { name: 'x-channel', value: 'OP_ADMIN' }

    ];
  }


  /**
   * @function formatData formats the data for submit
   * @returns returns the formatted data
   */
  public formatData(model: any, fieldsList: any[], organization?: any) {
    const createRequest: any = {};
  
    createRequest['customer_email'] = model['customer_email'] || '';
  
    createRequest['product'] = model['product'] || '';
    createRequest['product_feature'] = model['product_feature'] || '';
    
      fieldsList.forEach(field => {
        const value = model[field.fieldId];
    
        if (value !== '' && value !== undefined && value !== null && field.fieldId !== 'attachment') {
          if (field.type === 'array') {
            createRequest[field.fieldId] = Array.isArray(value) ? value : [];
          } else {
            createRequest[field.fieldId] = value;
          }
        }})
    ;
  
    return createRequest;
  }

  /**
   * @function onChangeSubscriber formats the model fields when the subscriber changes
   * @returns model return the formated model
   */
  public onChangeSubscriber(model, fieldsList, vehicle, customer) {
    const reporter = this.ngRedux.getState().auth.email;
    const isApiError = this.ngRedux.getState().admin.otherParams['trigger'] === 'error-dialog';
    const otherParams = this.ngRedux.getState().admin.otherParams;
    for (const field of fieldsList) {
      if (field['name'] === 'IMEI') {
        model[field['fieldId']] = vehicle.imei ? vehicle.imei : '';
      }
      if (field['name'] === 'VIN Number' && vehicle.vin) {
        model[field['fieldId']] = vehicle.vin;
      }
      if (field['name'] === 'Customer Name') {
        if (Object.keys(customer).length > 0 && !!customer['firstName'] && !!customer['lastName']) {
          model[field['fieldId']] = customer['firstName'] + ' ' + customer['lastName'];
        }
      }
      if (field['name'] === 'Requestor Name') {
        if (Object.keys(customer).length > 0 && !!customer['firstName'] && !!customer['lastName']) {
          model[field['fieldId']] = customer['firstName'] + ' ' + customer['lastName'];
        }
      }
      if (field['name'] === 'Requestor Email') {
        if (Object.keys(customer).length > 0 && customer['emails'] && customer['emails'][0] && customer['emails'][0]['emailAddress']) {
          model[field['fieldId']] = customer['emails'][0]['emailAddress'];
        }
      }
      if (field['name'] === 'Customer Email') {
        if (Object.keys(customer).length > 0 && !!customer['emails'] && !!customer['emails'][0] && !!customer['emails'][0]['emailAddress']) {
          model[field['fieldId']] = customer['emails'][0]['emailAddress'];
        }
      }
      if (field['name'] && field['name'].includes('Priority')) {
        if (field['defaultValues'].length > 0) {
          model[field['fieldId']] = field['defaultValues'][0]['value'];
        }
      }
      if (field['name'] && field['name'].includes('Reporter Email')) {
        if (reporter) {
          model[field['fieldId']] = reporter;
        }
      }
      if (field['name'] && field['name'].includes('Short Description') && isApiError) {
        model[field['fieldId']] = 'API Error';
      }
      if (field['name'] && field['name'].includes('Detailed Description') && isApiError) {
        model[field['fieldId']] = 'API: ' + otherParams['api'] + '\n\n' +
          'Error Description: ' + otherParams['errorMessage'];
      }
    }
    return model;
  }
}
